import ReactStars from "react-rating-stars-component";
import React, { Component } from "react";

class SimpleGetRating extends Component {
  state = {};
  ratingChanged = (newRating) => {
    this.props.handleRatingChange(newRating);
  };

  render() {
    return (
      <ReactStars
        count={5}
        onChange={this.ratingChanged}
        size={30}
        emptyIcon={<i className="far fa-star"></i>}
        fullIcon={<i className="fa fa-star"></i>}
        activeColor="#ffd700"
      />
    );
  }
}
// console.clear();
export default SimpleGetRating;
